const o = (e) => {
  try {
    const r = sessionStorage.getItem(e);
    return r ? JSON.parse(r) : null;
  } catch (r) {
    return console.error("Error reading from sessionStorage", r), null;
  }
};
export {
  o as r
};
